import { DropdownOptions } from "../../Components/dropdownOptions";

export const SUBJECT_TYPE_OPTIONS: DropdownOptions[] = [
  {
    text: "Academic",
    value: "ACADEMIC",
  },
  {
    text: "Grade specific",
    value: "GRADE_SPECIFIC",
  },
  {
    text: "Holistic",
    value: "HOLISTIC",
  },
];
